import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const ReportsPurchasesPage = () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/reports/reportsPurchases/purchases`);
    }
  }, [match]);

  return null;
};

export default ReportsPurchasesPage;
